export const MAIN_PAGE_CTA_ID = 'main-page-cta';
